/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getCycleDays } from 'app/entities/cycle-day/cycle-day.reducer';
import { TemperatureType } from 'app/shared/model/enumerations/temperature-type.model';
import { createEntity, getEntity, reset, updateEntity } from './temperature.reducer';

export const TemperatureUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const cycleDays = useAppSelector(state => state.cycleDay.entities);
  const temperatureEntity = useAppSelector(state => state.temperature.entity);
  const loading = useAppSelector(state => state.temperature.loading);
  const updating = useAppSelector(state => state.temperature.updating);
  const updateSuccess = useAppSelector(state => state.temperature.updateSuccess);
  const temperatureTypeValues = Object.keys(TemperatureType);

  const handleClose = () => {
    navigate(`/temperature${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getCycleDays({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.value !== undefined && typeof values.value !== 'number') {
      values.value = Number(values.value);
    }
    if (values.time !== undefined && typeof values.time !== 'number') {
      values.time = Number(values.time);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...temperatureEntity,
      ...values,
      cycleDay: cycleDays.find(it => it.id.toString() === values.cycleDay?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          type: 'PRECYCLE',
          ...temperatureEntity,
          cycleDay: temperatureEntity?.cycleDay?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.temperature.home.createOrEditLabel" data-cy="TemperatureCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.temperature.home.createOrEditLabel">Create or edit a Temperature</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="temperature-id"
                  label={translate('tinyMedicRestApp.temperature.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.temperature.value')}
                id="temperature-value"
                name="value"
                data-cy="value"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.temperature.time')}
                id="temperature-time"
                name="time"
                data-cy="time"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.temperature.type')}
                id="temperature-type"
                name="type"
                data-cy="type"
                type="select"
              >
                {temperatureTypeValues.map(temperatureType => (
                  <option value={temperatureType} key={temperatureType}>
                    {translate(`tinyMedicRestApp.TemperatureType.${temperatureType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.temperature.comments')}
                id="temperature-comments"
                name="comments"
                data-cy="comments"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.temperature.forJanani')}
                id="temperature-forJanani"
                name="forJanani"
                data-cy="forJanani"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.temperature.active')}
                id="temperature-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.temperature.draft')}
                id="temperature-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.temperature.cursor')}
                id="temperature-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.temperature.lastUpdated')}
                id="temperature-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.temperature.microSec')}
                id="temperature-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.temperature.timestampEntry')}
                id="temperature-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="temperature-cycleDay"
                name="cycleDay"
                data-cy="cycleDay"
                label={translate('tinyMedicRestApp.temperature.cycleDay')}
                type="select"
              >
                <option value="" key="0" />
                {cycleDays
                  ? cycleDays.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/temperature" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TemperatureUpdate;
